document.getElementById("checkout").addEventListener("click", async function (event) {
  event.preventDefault();
  const dateValue = document.querySelector("#deliver_date").value,
    selectedDay = new Date(dateValue).getDate(),
    timeValue = document.getElementById("deliver_time").value;
  if (dateValue === "") return event.preventDefault(), alert("\u304A\u5C4A\u3051\u5E0C\u671B\u65E5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"), !1;
  if (timeValue === "") return event.preventDefault(), alert("\u304A\u5C4A\u3051\u6642\u9593\u5E2F\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"), !1;
  await setCartAttribute()
});
async function setCartAttribute() {
  const deliver_date = document.querySelector("#deliver_date").value != "" ? document.querySelector("#deliver_date").value : "\u6307\u5B9A\u306A\u3057",
    deliver_time = document.getElementById("deliver_time").value != "" ? document.getElementById("deliver_time").value : "\u6307\u5B9A\u306A\u3057";
  console.log({
    deliver_date
  }), document.querySelector('[name="checkout"]').classList.add("disabled");
  const cartItems = await fetch(window.Shopify.routes.root + "cart.js").then(response => response.json());
  console.log(cartItems);
  async function updateItems() {
    const results = [];
    console.log(cartItems.items);
    const is_setItem = cartItems.items.find(item2 => (console.log(Object.keys(item2.properties).length), Object.keys(item2.properties).length > 0)),
      item = is_setItem || cartItems.items[0];
    if (console.log({
        is_setItem
      }), console.log({
        deliver_date
      }), console.log({
        deliver_time
      }), deliver_time !== "\u6307\u5B9A\u306A\u3057" && deliver_date !== "\u6307\u5B9A\u306A\u3057") {
      const result2 = await (await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: {
            \u304A\u5C4A\u3051\u5E0C\u671B\u65E5: deliver_date,
            \u304A\u5C4A\u3051\u6642\u9593\u5E2F: deliver_time
          }
        })
      })).json();
      results.push(result2)
    } else results.push("not change");
    return results
  }
  const body = JSON.stringify({
      attributes: {
        "Delivery-Date": deliver_date,
        "Delivery-Time": deliver_time
      }
    }),
    result = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body
    });
  updateItems().then(() => {
    setTimeout(() => {
      document.querySelector('[name="checkout"]').classList.remove("disabled"), window.location.href = "/checkout"
    }, 500)
  }).catch(error => {
    setTimeout(() => {
      document.querySelector('[name="checkout"]').classList.remove("disabled")
    }, 500), console.error(error)
  })
}
document.querySelector("#deliver_time").addEventListener("change", async () => {}), document.getElementById("deliver_date").addEventListener("change", async function (event) {
  const value = event.target.value;
  let boolAddDeliverTime = !1;
  add_deliver_time.forEach(item => {
    item.dates && item.dates.includes(value) && (changeTimes(item.times), boolAddDeliverTime = !0)
  }), boolAddDeliverTime || changeTimes(default_deliver_time)
});

function changeTimes(times) {
  const timeSelect = document.getElementById("deliver_time");
  timeSelect.innerHTML = "", times.forEach(time => {
    const option = document.createElement("option");
    option.value = time.value, option.innerText = time.label, timeSelect.appendChild(option)
  })
}